<template>
  <vs-popup class="holamundo domains-confirmation" :active="show" :buttons-hidden="true">
    <div class="prompt-title mb-2">
      <vs-icon class="block-confirmation-popup" icon="speakol-help" icon-pack="speakol"></vs-icon>
      <span class="confirmation-title">Confirmation</span>
    </div>

    <div class="prompt-body mb-10 mt-4">
      <p class="block-confirmation-desc">
        The following domains no longer display ads  belonging to this category. Would you like to stop targeting those domains, or maintain the same publishers’ targeting in case those publishers start displaying ads under this category in the future?
      </p>
    </div>

    <div class="prompt-title mb-2">
      Confirmation
    </div>

    <div class="prompt-table">
      <ul class="domains-list">
        <li v-for="(c, index) in domains" :key="index" class="flex">
          <vs-checkbox class="inline-block" v-model="selectedDomains" :vs-value="c.id"></vs-checkbox>
          <span class="font-bold">{{ c.name }}</span>
        </li>
      </ul>
    </div>

    <div class="flex flex-wrap mt-10 md:justify-end btns">
      <!-- Confirm Button -->
      <!-- <speakol-main-button class="ml-4 w-full" @click.native="confirm" mainAction = 'true' :buttonText = "'Confirm'"></speakol-main-button> -->
      <vs-button @click="confirm" :disabled="!selectedDomains.length" class="w-full ok-btn mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last">
        Keep Selected ({{ selectedDomains.length }})
      </vs-button>

      <!-- No Button -->
      <vs-button
        class="no-shadow w-full cancel-btn md:cancel-btn"
        type="border"
        text-color="#2C2C2C"
        color="#D9D9D9"
        @click="hide"
      >
        Remove All
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
import SpeakolMainButton from '@/components/speakol-template/SpeakolMainButton.vue'

export default {
  props: {
    domains: {
      type: Array,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    }
  },
  components: {
    SpeakolMainButton
  },
  watch: {
    domains () {
      this.selectedDomains = this.domains.map(i => i.id)
    }
  },
  data () {
    return {
      selectedDomains: []
    }
  },
  methods: {
    hide () {
      // this.$emit('hide')

      this.$emit(
        'confirm',
        this.domains.map(i => i.id)
      )
    },
    /**
     * Confirm methods fires only the unselected domains
     */
    confirm () {
      this.$emit(
        'confirm',
        this.domains.filter(
          i => this.selectedDomains.findIndex(v => v === i.id) === -1
        ).map(i => i.id)
      )
    }
  }
}
</script>


<style lang="scss">
/deep/ .con-vs-popup /deep/ .vs-popup--content {
  padding: 51px 51px 51px 56px;
}

/deep/ .con-vs-popup /deep/ .vs-popup {
  border-radius: 16px !important;
}

.btns button {
  border-radius: 3px;
  height: 40px;

  .cancel-btn {
    background: #fff;
  }
}

.ok-btn {
  background: #0092d7 !important;
  width: 185px !important;
}

.ok-btn:hover {
  box-shadow: none !important;
}

.prompt-title {
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  line-height: 40px;
  color: #2c2c2c;
}

.prompt-body {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #999;
}

/deep/.vs-popup {
  width: 893px;
  height: 456px;
}

.block-confirmation-popup {
  color: white;
  background-color: #faad14;
  border-radius: 100%;
  padding: 5px 5px;
  position: relative;
  top: 2px;
}

.block-confirmation-desc {
  color: rgba(0, 0, 0, 0.65);
}

.confirmation-title {
  font-weight: 500;
  font-size: 24px;
  margin-left: 20px;
}

.block-confirmation-note {
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  margin-top: 20px;
}

.domains-list {
  max-height: 184px;
  overflow-y: scroll;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 20px;

  li {
    line-height: 20px;
    margin-bottom: 15px;
    color: rgba(0, 0, 0, 0.65);
  }

  li::marker {
    font-size: 16px;
  }
}

@media (min-width: 768px) {
  .md\:cancel-btn {
    min-width: 112px !important;
    max-width: 140px;
  }
}

@media (max-width: 576px) {
  .ok-btn {
    width: 100% !important;
  }
}
</style>
